<template>
  <div class="contents-wrapper">
    <div class="contents-header">
      <div class="nav">
        <router-link to="/"><img :src="scroll_event_homeImage" /></router-link>
      </div>
    </div>
    <div class="contents-body">
      <div class="portfolio-top" />
      <div class="title">
        <h1 id="title">Nana6 project</h1>
        <p id="role">Editorial design<br />2010</p>
      </div>

      <div class="desc">
        <p id="desc">
          <b>Description</b><br />한국 디자인계의 정체성을 탐구하기 위한
          프로젝트로 11명의 작가와 디자이너가 초대되었고, 이 책은 그 만남의
          기록이다.
        </p>
        <p id="name">
          <b>Planning:</b> Sangsoo Ahn, Sangdo Kim, Haecheon Park<br /><b
            >Design:</b
          >
          Yuri Ahn, Liling Hwang, Hyewon Min, Hayan Park, Minyoung Yu<br /><b
            >Art director:</b
          >
          Chansin Park<br /><b>Editor:</b> Guhong Min
        </p>
      </div>
      <div class="img-contents">
        <img src="/images/portfolios/nana/01.jpg" />
        <img class="mini" src="/images/portfolios/nana/02.jpg" />
        <img class="mini" src="/images/portfolios/nana/03.jpg" />
        <img class="mini" src="/images/portfolios/nana/04.jpg" />
        <img class="mini" src="/images/portfolios/nana/05.jpg" />
        <img class="mini" src="/images/portfolios/nana/06.jpg" />
        <img class="mini" src="/images/portfolios/nana/07.jpg" />
        <img class="mini" src="/images/portfolios/nana/08.jpg" />
        <img class="mini" src="/images/portfolios/nana/09.png" />
      </div>
    </div>
    <div class="move-btn">
      <span class="prev" @click="move('nine-o-clock')">
        <img src="/images/chevron-left.svg" />Previous
      </span>
      <span class="next" @click="move('save-earth')">
        Next<img src="/images/chevron-right.svg" />
      </span>
    </div>
    <div class="contents-footer">
      <span class="name">
        <img src="/images/home_full_name.svg" />
      </span>
      <span class="copyright">
        <p>2021 ⓒ ahnyuri</p>
      </span>
    </div>
  </div>
</template>

<script>
import { ScrollEventMixin } from "@/mixins/ScrollEventMixin";
export default {
  name: "DetailNana",
  mixins: [ScrollEventMixin],
  data() {
    return {};
  },
  methods: {
    move(url) {
      this.$router.push(`/detail/${url}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/views/HomeHeader.scss";
@import "@/views/HomeFooter.scss";
.contents-body {
  // display: flex;
  // outline: 1px red dashed;
  // height: 1500px;
}
.contents-wrapper {
  overflow-x: hidden;
}
.portfolio-top {
  width: 100%;
  height: 800px;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  background-image: url("/images/portfolios/nana/top.jpg");
}

.title {
  float: left;
  margin-left: 10%;
  display: inline-block;
  margin-bottom: 0;
}

.title h1 {
  color: #303133;
  margin-top: 100px;
}
.title p {
  font-size: 13px;
  line-height: 20px;
  color: #606266;
  margin-top: -5px;
}
.desc {
  float: right;
  margin-right: 10%;
  margin-top: 85px;
  margin-bottom: 100px;
  width: 550px;
  font-size: 16px;
  line-height: 26px;
  color: #606266;
  display: inline-block;
}

.img-contents img {
  margin-top: 150px;
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
}

.img-contents img.mini {
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 50px;
}

.move-btn {
  cursor: pointer;
  width: 100%;
  display: inline-block;
}
.move-btn a {
  cursor: pointer;
}
.move-btn > .prev {
  color: #606266;
  margin-left: 5%;
  margin-top: 100px;
  margin-bottom: 100px;
  float: left;
}
.prev:hover {
  color: #303133;
}
.move-btn > .next {
  color: #606266;
  margin-right: 5%;
  margin-top: 100px;
  margin-bottom: 100px;
  float: right;
}
.next:hover {
  color: #303133;
}
@import "@/views/DetailZMedia.scss";
</style>
